import React, { useEffect, useState } from 'react'; 
import { createBomType, getBomTypes, updateBomType, deleteBomType } from '../api/bomTypesService';
import TableComponent from './TableComponent';
import Pagination from '../view/common/pagination/Pagination';

import { Plus } from 'lucide-react';
import '../styles/common/sub-menu.css';
import '../styles/common/spinner.css';
import '../styles/common/icon-style.css'
import "../styles/ItemModels.css"; 
import '../styles/common/toplayout.css'
import '../styles/common/btn.css'

// step : 1
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../redux/slices/store";
import { updateFilters } from "../redux/slices/filterSlice";

interface BomType {
  _id: string;
  type: string;
  status: 'ACTIVE' | 'INACTIVE';
}

const BomTypesComponent: React.FC = () => {
  const [bomTypes, setBomTypes] = useState<BomType[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newBomType, setNewBomType] = useState<BomType>({ _id: '', type: '', status: 'ACTIVE' });
  const [editingBomType, setEditingBomType] = useState<BomType | null>(null);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [searchTerm,setSearchTerm] = useState<string>("");

  // step: 2
    const dispatch = useDispatch();
    const filters = useSelector((state: RootState) => state.filters);
    const  permission = useSelector((state:RootState) => state.permissions)
      
  

  useEffect(() => {
    fetchBomTypes();
  }, [currentPage, itemsPerPage,searchTerm,filters]);
  
  const fetchBomTypes = async () => {
    setLoading(true);
    try {
      const response = await getBomTypes({
        page: currentPage,
        limit: itemsPerPage,
        search: searchTerm,
        filter: filters,   // step: 4
      });
      
      setBomTypes(response.data.data); 
      setTotalItems(response.data.pagination?.total || 0);
      setTotalPages(response.data.pagination?.totalPages || 1);
    } catch (error) {
      console.error('Error fetching BOM types:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCreateOrUpdate = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      if (editingBomType) {
        await updateBomType(editingBomType._id, { type: newBomType.type, status: newBomType.status });
      } else {
        await createBomType({ type: newBomType.type, status: newBomType.status });
      }
      fetchBomTypes();
      setIsModalOpen(false);
      setNewBomType({ _id: '', type: '', status: 'ACTIVE' });
      setEditingBomType(null);
    } catch (error) {
      console.error('Failed to save BOM type:', error);
    }
  };

  const handleDelete = async (id: string) => {
    try {
      await deleteBomType(id);
      fetchBomTypes();
    } catch (error) {
      console.error('Error deleting BOM type:', error);
    }
  };

  const columns = [
    { key: 'type', label: 'Type' },
    { key: 'status', label: 'Status' }
  ];

  return (
    <div className="item-models-container">
      <div className="item-models-header">
      <div className="border">
      <div className="start-end-layout"> 
        <div className="breadcrumb-nav">
          <span>Master Item</span>
          <span>BOM</span>
        </div>
        {permission.menus.bomtypes.create ?
        <div className="items-button-container">
          <button className="item-models-add-btn tooltip-wrapper" onClick={() => { setIsModalOpen(true); setEditingBomType(null); }}>
            <Plus size={16} />
          </button>
        </div>
        :<></>}
      </div>
      </div></div>

      {loading ? (
        <div className="spinner"></div>
      ) : (
        <>
          <div className="box-container">
            <TableComponent
              columns={columns}
              data={bomTypes}
              onEdit={(row) => { setEditingBomType(row); setNewBomType(row); setIsModalOpen(true); }}
              onDelete={handleDelete}
            />
          
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
            itemsPerPage={itemsPerPage}
            setItemsPerPage={setItemsPerPage}
            totalItems={totalItems}
          /></div>
        </>
      )}

      {isModalOpen && (
        <div className="item-models-modal-overlay">
          <div className="item-models-modal">
            <div className="item-models-modal-header">
              <h5>{editingBomType ? 'Edit BOM Type' : 'Create BOM Type'}</h5>
              <button className="item-models-modal-close" onClick={() => setIsModalOpen(false)}>✖</button>
            </div>
            <form onSubmit={handleCreateOrUpdate}>
              <input
                type="text"
                value={newBomType.type}
                onChange={(e) => setNewBomType({ ...newBomType, type: e.target.value })}
                placeholder="Type"
                required
              />
              <select
                value={newBomType.status}
                onChange={(e) => setNewBomType({ ...newBomType, status: e.target.value as 'ACTIVE' | 'INACTIVE' })}
              >
                <option value="ACTIVE">ACTIVE</option>
                <option value="INACTIVE">INACTIVE</option>
              </select>
              <button type="submit">{editingBomType ? 'Update' : 'Add'}</button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default BomTypesComponent;
